import React from 'react';

import CoreContainer from 'core/components/CoreContainer';
import { PanelSetupRequired } from 'core/components/editor/EditToggle';
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { nDef } from 'core/util/TypeUtils';
import ContainerView from 'panels/container/view/Container.view';
import { GridCont } from './Grid';
import LayoutConfig from './LayoutConfig';

/**
 * @overview: Container type panel for defining layouts with CSS Grid.
 * A {@link ContainerPanel} is automatically inserted for each column /
 * grid cell depending on configuration.
 *
 * @author: jesposito
 */



@Panel({id: "layout", configClass: LayoutConfig})
export class LayoutPanel extends React.PureComponent<IPanelProps<LayoutConfig>, any> {

	public render() {
		const { config } = this.props;

		if(nDef(config) || nDef(config.layout.columns) || config.layout.columns.length <= 0) {

			// TODO check if editing is enabled
			return (
				<PanelSetupRequired description="Define a grid to get started." />
			);
		}

		const columnWidths: string[] = config.layout.columns.map((l) => (
			l.width
		));

		// TODO add props interface

/*
		const style = {
			display: "grid",
			minHeight: config.fullHeight ? "100vh" : "auto"
		};

		const column = {
			gridTemplateColumns: columnWidths.join(" "),
			msGridTemplateColumns: columnWidths.join(" "),
		};

		const row = {
			gridTemplateRows: columnWidths.join(" "),
			msGridTemplateRows: columnWidths.join(" "),
		}; */

		const columns = config.layout.columns.map((l, i) => (
			<ContainerView key={l.containerInstance} viewKey={"grid-item-" + i} layoutType={config.layout.type} layoutIndex={i}>
				<CoreContainer key={l.containerInstance} children={[l.containerInstance]} />
			</ContainerView>
		));

		// const gird = LayoutType.COLUMN === config.layout.type ? {...style, ...column} : {...style, ...row};

		// dont use a styled.component for the grid because of compatibility issues with react-dnd
		return (
			<GridCont {...{type: config.layout.type, fullHeight: config.fullHeight, breakPoint: config.breakPoint, units: columnWidths} as any}>
				{columns}
			</GridCont>
		);
	}
}













// WEBPACK FOOTER //
// ./src/panels/layout/Layout.panel.tsx